import React, { ComponentType } from 'react';
import type { SvgIconProps } from '@fx-ui/icon';
import classNames from 'classnames';

export interface MultiGradientThemeIconProps extends Omit<SvgIconProps, 'component'> {
    /**
     * 图标组件，来自 @fx-ui/icon
     */
    icon: ComponentType<SvgIconProps>;
}

/**
 * MultiGradientThemeIcon 多渐变色主题色变化的图标组件
 * @returns 图标组件
 */
const MultiGradientThemeIcon: React.FC<MultiGradientThemeIconProps> = (props) => {
    const { icon: IconComponent, className, ...restProps } = props;

    if (!IconComponent) {
        return null;
    }

    return (
        <IconComponent
            {...restProps}
            className={classNames('fx-multi-gradient-theme-icon', className)}
        />
    );
};

export default MultiGradientThemeIcon;
